import type { IUnit } from '@/service/vpc/types/IUnit';

type LocationSource = Pick<IUnit, 'bestKnownLocation' | 'metadata'>;

// `metadata.homePort` is a user-set, stable reference location and is preferred whenever
// configured. `bestKnownLocation` is telemetry-derived and updates on its own over time, so it's
// only used as a fallback for units without a home port set, to avoid the displayed location
// shifting out from under a user who has already set one.
export const getUnitLocation = (unit: LocationSource): string => {
  const homePortAddress = unit.metadata?.homePort?.address?.trim();
  if (homePortAddress) return homePortAddress;

  const city = unit.bestKnownLocation?.city?.trim();
  const country = unit.bestKnownLocation?.country?.trim();
  return [city, country].filter(Boolean).join(', ');
};
